/*
 * @providesModule GenericHeaderStyle
 *
 * Styles for GenericHeader. Background is transparent; layout supports
 * optional left icon and optional center content.
 */

import {StyleSheet} from 'react-native';
import SkillzStyle from 'SkillzStyle';

const {textColorPrimary} = SkillzStyle.fullStyles;

export const createStyles = () => {
  return StyleSheet.create({
    container: {
      width: '100%',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      backgroundColor: 'transparent',
      minHeight: 50,
    },
    leftIconSlot: {
      width: 50,
      height: 50,
      justifyContent: 'center',
      alignItems: 'flex-start',
    },
    centerSlot: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      paddingHorizontal: 8,
    },
    rightIconSlot: {
      width: 50,
      height: 50,
      justifyContent: 'center',
      alignItems: 'flex-end',
    },
    iconTouchable: {
      width: 50,
      height: 50,
      justifyContent: 'center',
      alignItems: 'center',
    },
    leftIcon: {
      width: 24,
      height: 24,
    },
    centerIcon: {
      height: 40,
      width: 70,
      marginVertical: 24,
    },
    rightIcon: {
      width: 24,
      height: 24,
    },
    centerTouchable: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      paddingHorizontal: 8,
    },
    defaultLogoContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    },
    defaultLogoIcon: {
      width: 32,
      height: 32,
      marginRight: 8,
    },
    defaultLogoWordmark: {
      width: 120,
      height: 32,
    },
  });
};

export type GenericHeaderStyles = ReturnType<typeof createStyles>;
